import logo from './image/logo/logo.png';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Home from './Components/Home/Home';
import Navigations from './Components/Navigations/Navigations';
import Contact from './Components/Contact/Contact';
import Porfolios from './Components/Porfolios/Porfolios';
import PortfolioDetails from './Components/PortfolioDetails/PortfolioDetails';
import AboutUs from './Components/AboutUs/AboutUs';
function App() {
  return (
    <div className="App">
      <Router>
        <Navigations></Navigations>
        <Switch>
          <Route exact path="/">
            <Home></Home>
          </Route>
          <Route path="/home">
            <Home></Home>
          </Route>
          <Route path="/aboutUs">
            <AboutUs></AboutUs>
          </Route>
          <Route path="/Porfolios">
            <Porfolios></Porfolios>
          </Route>
          <Route path="/Portfolio/:PorfoliosId">
            <PortfolioDetails></PortfolioDetails>
          </Route>
          <Route path="/contact">
            <Contact></Contact>
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
